import { atom } from "recoil";

export const hasBillingInformationState = atom<boolean | undefined>({
  key: "hasBillingInformationState",
  default: undefined
})